import { Environment as e } from "./types.mjs";
//#region src/classifyHostEnvironment.ts
function t(t) {
	let n = (t ?? "").toLowerCase();
	return n === "maatstays.com" || n.endsWith(".maatstays.com") ? e.Production : n === "maatstays.wtf" || n.endsWith(".maatstays.wtf") ? e.Staging : e.Local;
}
//#endregion
export { t as classifyHostEnvironment };
